export default {
  getHistoryItems(state) {
    return state.historyItems
      .filter((item) => item.description)
      .sort(function (a, b) {
        return new Date(b.timestamp) - new Date(a.timestamp);
      });
  },
};
